import Tooltip from '@material-ui/core/Tooltip'
import React, { Component } from 'react'
import {
  Create,
  FormDataConsumer,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  SimpleForm,
  TextInput,
  email,
  required,
  translate,
} from 'react-admin'
import { Field } from 'redux-form'
import { CustomToolbarAdd } from '../categories/CategoryAdd'
import CategoryFilterField from '../categories/CategoryFilterField'

const validateRequiredEmail = [required(), email()]

const NameField = ({ record }) => (
  <Tooltip title={record.description} key={record.id} placement="bottom">
    <div>{record.name}</div>
  </Tooltip>
)
class UserAdd extends Component {
  render() {
    return (
      <Create {...this.props}>
        <SimpleForm redirect="list" toolbar={<CustomToolbarAdd />}>
          <SelectInput
            source="loginType"
            choices={[
              { id: 'Username-Password-Authentication', name: 'Email & Password' },
              { id: 'google-oauth2', name: 'Google' },
              { id: 'microsoft', name: 'Microsoft' },
            ]}
            defaultValue="Username-Password-Authentication"
          />
          <TextInput source="email" type="email" validate={validateRequiredEmail} />

          <FormDataConsumer>
            {({ formData, ...rest }) =>
              formData.loginType === 'Username-Password-Authentication' && (
                <div>
                  <TextInput source="firstName" />
                  <br />
                  <TextInput source="familyName" />
                </div>
              )
            }
          </FormDataConsumer>

          <ReferenceArrayInput source="userRoles" reference="roles">
            <SelectArrayInput optionText={<NameField />} translateChoice={false} />
          </ReferenceArrayInput>

          <SelectInput
            source="language"
            choices={[
              { id: 'en', name: 'main.english' },
              { id: 'nl', name: 'main.dutch' },
              { id: 'fr', name: 'main.french' },
              { id: 'es', name: 'main.spanish' },
              { id: 'da', name: 'main.danish' },
              { id: 'it', name: 'main.italian' },
              { id: 'ro', name: 'main.romanian' },
              { id: 'no', name: 'main.norwegian' },
              { id: 'de', name: 'main.german' },
            ]}
            defaultValue={this.props.locale}
          />
          <Field name="category" component={CategoryFilterField} />
        </SimpleForm>
      </Create>
    )
  }
}

export default translate(UserAdd)
